/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const forgotPasswordConfirmPostRequestSchema = z.object({
  client: z.string(),
  client_secret: z.string(),
  confirmation_code: z.string(),
  email: z.string(),
  password: z.string(),
});
